import { Component, OnInit, Input } from '@angular/core';
import { Usuario, TipoUsuario } from '../../../interfaces/usuario';
import { UsuarioService } from '../../../providers/usuario.service';
import { MatTableDataSource, Sort, PageEvent } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { PermisoService } from '../../../providers/permiso.service';
import { AuthenticationService } from '../../../providers/auth.service';
import { Telefono } from '../../../components/telefono/telefono.component';

@Component({
  selector: 'app-ver-usuarios',
  templateUrl: './ver-usuarios.component.html',
  styleUrls: ['./ver-usuarios.component.scss']
})
export class VerUsuariosComponent implements OnInit {
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaUsuariosColumnas = ['usuario', 'apellido', 'nombre', 'telefono', 'email', 'tipoUsuario'];
  usuariosDataSource = new MatTableDataSource();
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtro: string = '';
  getUsuariosSuscripcion = new Subscription();
  usuariosCount: number = 0;
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las incidencias

  constructor(
    private usuarioService: UsuarioService,
    private permisoService: PermisoService,
    public authenticationService: AuthenticationService
  ) {
    this.permisoService.tienePermiso('USUARIO-ACCIONES').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaUsuariosColumnas.push('acciones');
      }
    });
  }

  ngOnInit() {
    // set valores iniciales
    this.sort.active = 'apellido';
    this.sort.direction = 'asc';
    this.page.pageIndex = 0;
    this.page.pageSize = +localStorage.getItem('itemsPorPagina') || 10;
    this.page.length = 0;
    this.actualizarTabla();
  }

  onFiltro(filterValue: string) {
    this.page.pageIndex = 0;
    this.filtro = filterValue.trim().toLowerCase();
    this.actualizarTabla();
  }

  sortData(sort: Sort) {
    this.page.pageIndex = 0;
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('itemsPorPagina', pageEvent.pageSize.toString()); // los items por pagina se recuerdan
    this.page = pageEvent;
    this.actualizarTabla();
  }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo
        this.cargando = true;
      }, 750);

      if (this.getUsuariosSuscripcion && !this.getUsuariosSuscripcion.closed) {
        this.getUsuariosSuscripcion.unsubscribe();
      }

      var filtros: any = { // array de filtros internos
        generico: this.filtro
      };

      this.getUsuariosSuscripcion = this.usuarioService
        .getUsuarios(
          {
            page: this.page.pageIndex,
            pageSize: this.page.pageSize
          },
          {
            sort: this.sort.active,
            order: this.sort.direction
          },
          Object.assign(filtros, this.filtrosExternos) // filtros del componente mas los filtros según donde se muestra el componente
        )
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.usuariosCount = respuesta.data.total;
              }

              var usuarios: Usuario[] = []; // array de datos obtenidos
              respuesta.data.usuarios.forEach(usuario => {
                usuarios.push(
                  new Usuario(
                    usuario.id,
                    usuario.usuario,
                    usuario.email,
                    <TipoUsuario>{
                      id: usuario.tipoUsuario.id,
                      descripcion: usuario.tipoUsuario.descripcion
                    },
                    null,
                    usuario.nombre,
                    usuario.apellido,
                    new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                    +usuario.estado,
                    usuario.puesto,
                    !!+usuario.editable,
                    !!+usuario.eliminable
                  )
                );
              });

              this.usuariosDataSource.data = usuarios;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  ngOnDestroy() {
    if (this.getUsuariosSuscripcion && !this.getUsuariosSuscripcion.closed) {
      this.getUsuariosSuscripcion.unsubscribe();
    }
  }
}
